import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import { Modal } from '@material-ui/core';
import KobooButton from './KobooButton';
import { withStyles } from '@material-ui/core/styles';
import { KOBOO_BLUE } from '../../constants/colors';

const styles = theme => {
  return {
    modal: {
      outline: 'none',
      textAlign: 'center',
      marginTop: theme.spacing(3),
      width: '50em',
      marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
        width: '100%',
        height: '100%',
      },
    },
    content: {
      outline: 'none',
      backgroundColor: 'white',
      borderRadius: "12px",
      height: 'auto',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '100%',
      },
      paddingBottom: '1em'
    },
    icon: {
      color: KOBOO_BLUE,
      fontSize: '3em',
      marginTop: '20px',
      marginBottom: '10px',
    },
    buttonItem: {
      padding: '3px 4em',
      [theme.breakpoints.down('md')]: {
        padding: '3px 2em',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '3px 1em',
      },
    },
  };
};
const ValidationModal = (props) => {
  const {
    visible,
    handleValidate,
    handleClose,
    title,
    text,
    validationText,
    closeText,
    classes,
  } = props;

  return (
    <Modal
      open={visible}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modal}
    >
      <div className={classes.content}>
        <DeleteIcon className={classes.icon} />
        <h2>{title}</h2>
        <p>{text}</p>
        <Grid container>
          <Grid item xs={6} className={classes.buttonItem}>
            <KobooButton width={'100%'} onClick={handleClose} variant="outlined">
              {closeText}
            </KobooButton>
          </Grid>
          <Grid item xs={6} className={classes.buttonItem}>
            <KobooButton width={'100%'} onClick={() => {handleValidate(); handleClose();}}>
              {validationText}
            </KobooButton>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

export default withStyles(styles)(ValidationModal);



// WEBPACK FOOTER //
// ./src/components/Layout/ValidationModal.jsx